/*
 * File: cell-user-role.ts
 * Created: 2025-12-05 14:09:18
 * Author: Val Liu <valuis0429@gmail.com>
 * -----
 * Last Modified: 2025-12-08 19:07:30
 * Modified By: Val Liu <valuis0429@gmail.com>
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";
import { UITag } from "@root/core/tags";

@Component
@UITag.setDefault({
    uiAlign: "center",
})
export default class CellUserRole extends BaseTableBodyCell {}
